/** @format */
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { StyledContainer, StyledCustomSelect } from './index';
import { CustomSelectAlignment, CustomSelectSkeletonProps } from './types';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'custom-select-skeleton';

const StyledContainerSkeleton = styled(StyledContainer)`
    pointer-events: none;
`;

export const CustomSelectSkeleton: FunctionComponent<
    CustomSelectSkeletonProps
> = ({ 'data-testid': dataTestId = DEFAULT_TEST_ID, ...otherProps }) => (
    <StyledContainerSkeleton data-testid={dataTestId} {...otherProps}>
        <StyledCustomSelect alignment={CustomSelectAlignment.LEFT}>
            <Skeleton
                variant={SkeletonVariant.TEXT}
                width="100%"
                lineHeight={1.15}
            />
        </StyledCustomSelect>
    </StyledContainerSkeleton>
);
